import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

const TermsAndConditions: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <div className="bg-white border-b border-gray-200">
        <div className="max-w-4xl mx-auto px-6 py-4">
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-3">
              <img
                src="/vetriaAI.png"
                alt="VetriaAI Logo"
                className="w-10 h-10"
              />
              <span className="text-2xl font-bold text-gray-900">VetriaAI</span>
            </div>
            <Link
              to="/"
              className="flex items-center text-gray-600 hover:text-gray-900 font-medium"
            >
              <ArrowLeft className="w-4 h-4 mr-2" />
              Back to Home
            </Link>
          </div>
        </div>
      </div>

      <div className="max-w-4xl mx-auto px-6 py-12">
        <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-8">
          <pre className="text-gray-900 font-sans whitespace-pre-line text-base leading-relaxed">
{`VetriaAI Terms & Conditions

Last Updated: 09 October 2025

Welcome to VetriaAI. By accessing or using our platform, you agree to these Terms & Conditions (\u201CTerms\u201D).

1) Definitions
\u201CVetriaAI\u201D, \u201Cwe\u201D, \u201Cus\u201D, \u201Cour\u201D: VETRIAAI INNOVATION PRIVATE LIMITED
\u201CService\u201D: our web apps, APIs, assessments, analytics, and related materials
\u201CCustomer\u201D: organization or individual purchasing a plan
\u201CUser\u201D: anyone with an account (admins, recruiters, candidates)
\u201CContent\u201D: data you upload or generate (job descriptions, resumes, results, badges)

2) Account & Eligibility
You must provide accurate information and keep credentials secure. You are responsible for all activity under your account.

3) Acceptable Use
You agree not to:
Upload unlawful, discriminatory, or harmful content
Attempt to bypass security or misuse APIs
Reverse engineer or scrape at scale
Use results to unlawfully discriminate or violate labor laws

4) AI Outputs & Human Oversight
Our AI provides assessments, rankings, and insights. Outputs are advisory and require human review. You are responsible for final hiring decisions and for complying with applicable employment and anti-discrimination laws.

5) Data & Privacy
We process data per our Privacy Policy and any signed Data Processing Addendum (DPA). You represent that you have a lawful basis (e.g., consent or legitimate interests) to process candidate data.

6) Security & Compliance
We implement end-to-end encryption, MFA, RBAC, audit logs, backups, and follow standards including SOC 2 Type II, ISO 27001, GDPR, and CCPA (see Privacy Policy for details).

7) Integrations & Third Parties
Integrations (ATS/CRM/communications) may be subject to third-party terms. We\u2019re not liable for third-party systems.

8) Subscriptions, Billing & Taxes
Plans are prepaid and auto-renew unless cancelled. Prices exclude taxes unless stated. You authorize us to charge applicable taxes. Refunds are handled per the Cancellations & Refunds policy.

9) Intellectual Property
We retain all rights to the Service, documentation, algorithms, and models. You retain rights to your Content. You grant us a limited license to process it to provide the Service.

10) Confidentiality
Each party will protect the other\u2019s confidential information and use it only as necessary to deliver or receive the Service.

11) Service Levels & Changes
Target uptime: 99.9% monthly. We may improve or modify features; material changes will be communicated with reasonable notice.

12) Warranties & Disclaimers
The Service is provided \u201Cas is\u201D. We disclaim implied warranties to the extent permitted by law. We do not guarantee specific hiring outcomes.

13) Limitation of Liability
To the maximum extent permitted by law, our aggregate liability is limited to the fees paid in the 12 months before the claim. We are not liable for indirect or consequential damages (loss of profits, data, or business).

14) Indemnity
You agree to indemnify us for claims arising from your unlawful use of the Service or violation of these Terms.

15) Suspension & Termination
We may suspend or terminate for breach, security risk, or non-payment. You may terminate per your plan. Upon termination, we\u2019ll retain or delete data per the Privacy Policy and your settings.

16) Governing Law; Dispute Resolution
These Terms are governed by the laws of India (Hyderabad), excluding conflict-of-law rules. Disputes will be resolved via confidential arbitration in Hyderabad, India, unless your enterprise contract states otherwise.

17) Changes to Terms
We may update these Terms; we\u2019ll post the new version with a new \u201CLast updated\u201D date. Continued use constitutes acceptance.

18) Contact
VETRIAAI INNOVATION PRIVATE LIMITED
Registered office: H. No. 5-95/1, Flat No. G, Mokkapati Towers, Fathenagar Colony, K.v.rangareddy, Balanagar, Telangana, India, 500018
Support Email: info@vetriaai.com`}
          </pre>
        </div>
      </div>
    </div>
  );
};

export default TermsAndConditions;
